import {Badge} from "@mantine/core";
import {I18n} from "@aws-amplify/core";

// Theme colour names, so light and dark both work (§2). The one status badge for the
// module: the table column and the detail card both render it (§13).
const colors: { [key: string]: string } = {
    'Enabled': 'green',
    'Disabled': 'gray',
};

export const StatusBadge = ({status}: { status?: string }) => (
    <Badge color={status ? colors[status] ?? 'gray' : 'gray'} variant='light'>
        {status ? I18n.get(status) : '—'}
    </Badge>
);
